module.exports = __webpack_public_path__ + "static/L5Y2s-5c475350f41e7f6340da304407ce5520.jpg";